<template>
  <div v-if="visible" class="asg-overlay" @click.self="close">
    <div class="asg-panel">
      <div class="asg-head">
        <span class="asg-title"><i class="ri-scales-3-line"></i> Audit Scango - serveur envoyé vs comptabilisé</span>
        <button class="asg-close" @click="close"><i class="ri-close-line"></i></button>
      </div>

      <div class="asg-sub">
        <input v-model="filtre" class="asg-search" placeholder="Filtrer (n°, serveur, table)…" />
        <span class="asg-count">{{ commandesFiltrees.length }} commande(s)</span>
      </div>

      <div class="asg-body">
        <div v-if="commandesFiltrees.length === 0" class="asg-empty">
          <i class="ri-inbox-line"></i><span>Aucune commande à auditer.</span>
        </div>

        <div v-for="c in commandesFiltrees" :key="c.srvcmdid"
             class="asg-card" :class="{ 'asg-card-ecart': c._ecartQte }">
          <div class="asg-card-head">
            <div class="asg-card-id">
              <span class="asg-num">{{ c.numero || '-' }}</span>
              <span class="asg-metatxt">
                {{ c.serveur_nom || 'Serveur ?' }}<template v-if="c.table_nom"> · {{ c.table_nom }}</template>
              </span>
            </div>
            <div class="asg-badges">
              <span v-if="c._ecartQte" class="asg-badge asg-badge-warn"><i class="ri-alert-line"></i> Écart</span>
              <span class="asg-badge" :class="'st-' + c.statut">{{ c.statut }}</span>
              <span class="asg-badge asg-tr">{{ (c.transport || '').toUpperCase() }}</span>
            </div>
          </div>

          <div class="asg-montants">
            <span>Serveur : <b>{{ fmt(c._totServeur) }}</b></span>
            <span v-if="c._encaisse">Caisse : <b>{{ fmt(c._totCaisse) }}</b></span>
            <span v-if="c._encaisse" class="asg-diffmt"
                  :class="c._ecartMontant > 0 ? 'plus' : (c._ecartMontant < 0 ? 'moins' : '')">
              Écart : {{ c._ecartMontant > 0 ? '+' : '' }}{{ fmt(c._ecartMontant) }}
            </span>
          </div>

          <div v-if="!c._encaisse" class="asg-note">
            <i class="ri-time-line"></i> Pas encore encaissé - seul l'envoi serveur est disponible.
          </div>

          <table class="asg-diff">
            <thead>
              <tr><th>Article</th><th class="num">Serveur</th><th class="num">Caisse</th><th>État</th></tr>
            </thead>
            <tbody>
              <tr v-for="(l, idx) in c._diff" :key="idx" :class="'row-' + l.etat">
                <td>{{ l.nom || l.ean || '-' }}</td>
                <td class="num">{{ l.qteServeur }}</td>
                <td class="num">{{ l.qteCaisse }}</td>
                <td><span class="asg-etat" :class="'e-' + l.etat">{{ libelleEtat(l.etat) }}</span></td>
              </tr>
            </tbody>
          </table>

          <!-- Journal d'événements : retraits caisse (rupture/manuel) + modifs serveur -->
          <div v-if="c.evenements && c.evenements.length" class="asg-evts">
            <div class="asg-evts-title"><i class="ri-history-line"></i> Journal des modifications</div>
            <div v-for="(ev, i) in c.evenements" :key="i" class="asg-evt" :class="'act-' + ev.acteur">
              <span class="asg-evt-act">{{ ev.acteur }}</span>
              <span class="asg-evt-msg">{{ ev.message || (ev.type + ' - ' + ev.article_nom) }}</span>
              <span v-if="ev.motif" class="asg-evt-motif">{{ ev.motif }}</span>
              <span class="asg-evt-date">{{ ev.created_at }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
/**
 * Modal d'audit Scango (lecture seule). Reçoit du parent (form_index6) les lignes
 * du rapprochement backend et affiche, par commande, un diff CÔTE À CÔTE de ce que
 * le SERVEUR a envoyé (lignes_serveur) vs ce qui a été COMPTABILISÉ à la caisse
 * (lignes_caisse + montant). Purement présentationnel : aucun appel réseau ici.
 */
export default {
  name: "ModalAuditScango",

  data() {
    return { visible: false, filtre: "", commandes: [] };
  },

  computed: {
    commandesFiltrees() {
      const f = this.filtre.trim().toLowerCase();
      if (!f) return this.commandes;
      return this.commandes.filter(c =>
          String(c.numero || '').toLowerCase().includes(f) ||
          String(c.serveur_nom || '').toLowerCase().includes(f) ||
          String(c.table_nom || '').toLowerCase().includes(f));
    },
  },

  methods: {
    show(lignes) {
      this.commandes = (lignes || []).map(c => this._preparer(c));
      this.filtre = "";
      this.visible = true;
    },
    close() { this.visible = false; },

    _parse(s) {
      try { const a = JSON.parse(s || "[]"); return Array.isArray(a) ? a : []; }
      catch (e) { return []; }
    },

    /** Construit le diff d'une commande : union des articles clés par EAN (repli nom). */
    _preparer(c) {
      const serveur = this._parse(c.lignes_serveur);
      const caisse = this._parse(c.lignes_caisse);
      const encaisse = !!(c.encaisse_at || (c.lignes_caisse && c.lignes_caisse !== ''));

      const key = (l) => String(l.ean || '').trim() || ('n:' + String(l.nom || '').trim().toLowerCase());
      const map = new Map();
      const vide = (l) => ({ ean: l.ean, nom: l.nom, qteServeur: 0, qteCaisse: 0 });

      serveur.forEach(l => {
        const k = key(l); const o = map.get(k) || vide(l);
        o.qteServeur += (parseFloat(l.qte) || 0); o.nom = o.nom || l.nom; map.set(k, o);
      });
      caisse.forEach(l => {
        const k = key(l); const o = map.get(k) || vide(l);
        o.qteCaisse += (parseFloat(l.qte) || 0); o.nom = o.nom || l.nom; map.set(k, o);
      });

      const diff = [];
      let ecartQte = false;
      for (const o of map.values()) {
        let etat = 'ok';
        if (!encaisse) etat = 'nc';
        else if (o.qteServeur > 0 && o.qteCaisse === 0) etat = 'retire';
        else if (o.qteServeur === 0 && o.qteCaisse > 0) etat = 'ajoute';
        else if (o.qteServeur !== o.qteCaisse) etat = 'modifie';
        if (encaisse && etat !== 'ok') ecartQte = true;
        diff.push({
          ean: o.ean, nom: o.nom,
          qteServeur: o.qteServeur,
          qteCaisse: encaisse ? o.qteCaisse : '-',
          etat,
        });
      }

      const totServeur = serveur.reduce((s, l) => s + (parseFloat(l.montant) || 0), 0);
      const totCaisse = (c.montant_caisse != null && c.montant_caisse !== '')
          ? (parseFloat(c.montant_caisse) || 0)
          : caisse.reduce((s, l) => s + (parseFloat(l.montant) || 0), 0);

      return {
        ...c,
        _diff: diff,
        _encaisse: encaisse,
        _totServeur: totServeur,
        _totCaisse: encaisse ? totCaisse : 0,
        _ecartMontant: encaisse ? (totCaisse - totServeur) : 0,
        _ecartQte: ecartQte,
      };
    },

    libelleEtat(e) {
      return { ok: 'OK', ajoute: 'Ajouté', retire: 'Retiré', modifie: 'Modifié', nc: '-' }[e] || e;
    },
    fmt(n) {
      const v = parseFloat(n) || 0;
      return v.toLocaleString('fr-FR') + ' F';
    },
  },
};
</script>

<style scoped>
.asg-overlay {
  position: fixed; inset: 0; z-index: 10050;
  background: rgba(2, 6, 23, .66);
  display: flex; align-items: center; justify-content: center; padding: 18px;
}
.asg-panel {
  width: 100%; max-width: 860px; max-height: 90vh;
  background: #0f172a; color: #e2e8f0;
  border: 1px solid #1e293b; border-radius: 14px;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .5);
}
.asg-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid #1e293b; background: #111c33;
}
.asg-title { font-weight: 800; font-size: 15px; display: flex; align-items: center; gap: 8px; }
.asg-close {
  width: 34px; height: 34px; border-radius: 8px; border: 1px solid #334155;
  background: transparent; color: #94a3b8; cursor: pointer; font-size: 17px;
}
.asg-close:hover { color: #fca5a5; border-color: #7f1d1d; }
.asg-sub {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 18px; border-bottom: 1px solid #1e293b;
}
.asg-search {
  flex: 1; height: 36px; border-radius: 8px; border: 1px solid #334155;
  background: #0b1222; color: #e2e8f0; padding: 0 12px; font-size: 13px; outline: none;
}
.asg-search:focus { border-color: #3b82f6; }
.asg-count { font-size: 12px; color: #94a3b8; white-space: nowrap; }
.asg-body { padding: 14px 18px; overflow-y: auto; }
.asg-empty {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  padding: 40px 0; color: #64748b; font-size: 14px;
}
.asg-empty i { font-size: 34px; }

.asg-card {
  border: 1px solid #1e293b; border-radius: 12px; padding: 12px 14px;
  margin-bottom: 12px; background: #0b1222;
}
.asg-card-ecart { border-color: #b45309; box-shadow: 0 0 0 1px rgba(180, 83, 9, .35); }
.asg-card-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
.asg-card-id { display: flex; flex-direction: column; gap: 2px; }
.asg-num { font-weight: 800; font-size: 15px; }
.asg-metatxt { font-size: 12px; color: #94a3b8; }
.asg-badges { display: flex; gap: 6px; flex-wrap: wrap; }
.asg-badge {
  font-size: 10px; font-weight: 800; text-transform: uppercase;
  padding: 3px 7px; border-radius: 6px; background: #1e293b; color: #cbd5e1;
}
.asg-badge-warn { background: #7c2d12; color: #fed7aa; }
.asg-badge.st-encaissee { background: #14532d; color: #bbf7d0; }
.asg-badge.st-chargee { background: #1e3a8a; color: #bfdbfe; }
.asg-badge.st-annulee { background: #7f1d1d; color: #fecaca; }
.asg-tr { background: #334155; color: #e2e8f0; }

.asg-montants {
  display: flex; gap: 16px; flex-wrap: wrap;
  margin: 10px 0; font-size: 13px; color: #cbd5e1;
}
.asg-diffmt.plus { color: #fca5a5; font-weight: 800; }
.asg-diffmt.moins { color: #86efac; font-weight: 800; }
.asg-note {
  font-size: 12px; color: #fcd34d; margin: 6px 0 10px;
  display: flex; align-items: center; gap: 6px;
}

.asg-diff { width: 100%; border-collapse: collapse; font-size: 13px; }
.asg-diff th {
  text-align: left; font-size: 11px; text-transform: uppercase;
  color: #64748b; padding: 6px 8px; border-bottom: 1px solid #1e293b;
}
.asg-diff th.num, .asg-diff td.num { text-align: right; }
.asg-diff td { padding: 6px 8px; border-bottom: 1px solid #16233b; }
.asg-diff tr.row-ajoute td { background: rgba(20, 83, 45, .28); }
.asg-diff tr.row-retire td { background: rgba(127, 29, 29, .28); }
.asg-diff tr.row-modifie td { background: rgba(120, 53, 15, .28); }

.asg-etat {
  font-size: 11px; font-weight: 700; padding: 2px 7px; border-radius: 5px;
  background: #1e293b; color: #94a3b8;
}
.asg-etat.e-ajoute { background: #14532d; color: #bbf7d0; }
.asg-etat.e-retire { background: #7f1d1d; color: #fecaca; }
.asg-etat.e-modifie { background: #78350f; color: #fed7aa; }
.asg-etat.e-ok { background: #0f2a1a; color: #6ee7b7; }

/* Journal d'événements */
.asg-evts { margin-top: 10px; border-top: 1px dashed #1e293b; padding-top: 8px; }
.asg-evts-title { font-size: 11px; text-transform: uppercase; color: #64748b; font-weight: 700; margin-bottom: 6px; display: flex; align-items: center; gap: 5px; }
.asg-evt { display: flex; align-items: center; gap: 8px; font-size: 12px; color: #cbd5e1; padding: 3px 0; }
.asg-evt-act { font-size: 10px; text-transform: uppercase; font-weight: 800; padding: 2px 6px; border-radius: 5px; background: #1e293b; color: #94a3b8; flex-shrink: 0; }
.asg-evt.act-caisse .asg-evt-act { background: #78350f; color: #fed7aa; }
.asg-evt.act-serveur .asg-evt-act { background: #14532d; color: #bbf7d0; }
.asg-evt-msg { flex: 1; }
.asg-evt-motif { font-size: 10px; text-transform: uppercase; font-weight: 800; padding: 2px 6px; border-radius: 5px; background: #7f1d1d; color: #fecaca; }
.asg-evt-date { color: #64748b; font-size: 10px; }
</style>
